// extracted by mini-css-extract-plugin
module.exports = {"bioForm":"RegistrationForm_bioForm__2CSMl","bioFormStandalone":"RegistrationForm_bioFormStandalone__d46bU"};